// extracted by mini-css-extract-plugin
module.exports = {"helpCenter":"list_helpCenter__njbbD","helpCenterWrap":"list_helpCenterWrap__28Feb","helpItem":"list_helpItem__1KNCR","itemIcon":"list_itemIcon__8MMvr"};